module.exports = __webpack_public_path__ + "luciana_santos--526af78a.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/candidatos/luciana_santos.jpg
// module id = 167
// module chunks = 0